export const workflowRoutes = {
  root: '/workflow',
  workflow: (token: string) => `/workflows/${token}` as const,
  workflowVersion: (token: string) => `/workflow/${token}/version` as const,
  snippetWorkflow: '/workflow/snippet',
  taxonomyCatalog: '/workflow-taxonomy',
  details: (token: string) => `/workflow/${token}/details` as const,
  workflowVersionSchemaFields: (token: string) => `/workflow/${token}/version/schema-fields` as const,
} as const;
